import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
/**
 * * 2열 테이블
 */

interface IProps {
  children: React.ReactElement;
  thWidth?: string;
}
const TwoRowTable = ({ children, thWidth }: IProps) => {
  return <StyledTable thWidth={thWidth}>{children}</StyledTable>;
};

export default TwoRowTable;

const StyledTable = styled.table`
  width: 100%;
  th,
  td {
    border-top: 1px solid ${theme.colors.gray_3};
    border-bottom: 1px solid ${theme.colors.gray_3};
    text-align: left;
    padding: 0.7rem 0.9rem;
  }
  th {
    background-color: ${theme.colors.table_header};
    width: ${(props) => (props.thWidth ? `${props.thWidth}` : '15rem')};
  }
  td {
    width: 20rem;
  }
`;
